// Stripe is hidden for now — payments are recorded manually (cash / bank
// transfer) from the Payments page. Flipping this back on restores the
// Billing page (subscription + Stripe Connect), the Charge Card flow, and
// the member card-setup section on the profile page.
export const STRIPE_ENABLED: boolean = false;
